import { memo } from 'react';
import type { VFC } from 'react';

import type { LiveAssetsScheduleComponent } from '@vgtv/api-client/lib/component/live_assets_schedule';
import { useTranslation } from 'react-i18next';

import {
  AssetsSchedule,
  ROOT_CATEGORY_ID,
} from '../../../AssetsSchedule/AssetsSchedule';

import * as styles from './LiveSchedule.module.scss';

interface LiveScheduleProps {
  componentConfig: LiveAssetsScheduleComponent;
}

const LiveScheduleBase: VFC<LiveScheduleProps> = ({ componentConfig }) => {
  const { t } = useTranslation();

  const { header } = componentConfig;

  const title = header ?? t('Live')!;

  return (
    <div className={styles.container}>
      <AssetsSchedule title={title} categoryId={ROOT_CATEGORY_ID} />
    </div>
  );
};

export const LiveSchedule = memo(LiveScheduleBase);
